import { $getRoot } from "lexical";

/**
 * Builds plain text by joining root-level block nodes with a single \n,
 * matching how the backend (ROR) counts characters.
 *
 * This avoids three Lexical quirks:
 * 1. getTextContent() joins paragraphs with \n\n instead of \n
 * 2. <p><br></p> re-imports as a LineBreakNode ("\n") inside an
 *    otherwise empty paragraph, inflating the count on reload
 * 3. ListNode.getTextContent() uses \n\n between ListItemNodes;
 *    we collapse those to \n to match the DOM/backend counting
 *
 * SYNC: getPlainTextLengthFromHtml() in lib/text-sanitizer implements the
 * same counting algorithm via DOM traversal. Changes here must be mirrored there.
 */
export function getNormalizedTextContent(): string {
  const root = $getRoot();
  return root
    .getChildren()
    .map((child) => {
      const text = child.getTextContent();
      return /^\n+$/.test(text) ? "" : text;
    })
    .join("\n")
    .replace(/\n{2,}/g, "\n");
}

export function getNormalizedTextLength(): number {
  return getNormalizedTextContent().length;
}

/**
 * Returns the normalized length of a Lexical selection's text content,
 * collapsing the \n\n block separators to single \n to match getNormalizedTextLength().
 */
export function getNormalizedSelectionLength(selectionText: string): number {
  return selectionText.replace(/\n{2,}/g, "\n").length;
}
